import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Metro from "../Components/Metro";

const MetroDataAdmin = () => {
  const navigate = useNavigate();
  const [userlog, setUserlog] = useState(localStorage.getItem("Logkey"));

  useEffect(() => {
    if (userlog === undefined || userlog === null) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <Header />
      <Sidebar />
      <Metro />
      {/* <Footer/>    */}
    </>
  );
};

export default MetroDataAdmin;
